// Common translations used across multiple components
const commonTranslations = {
  en: {
    capabilities: "core capabilities",
    cookies: {
      label: "cookie consent",
      eyebrow: "cookies",
      text: "we'd like to use google analytics to understand how this site is used. it only runs if you accept. more in our",
      link: "privacy policy",
      decline: "decline",
      accept: "accept"
    },
    siteTitle: "thewhizkind",
    siteDescription: "thewhizkind is an independent creative and technology team based in Frankfurt am Main, working across design, web development, AI, automation and business.",
    siteTagline: "Design, Technology & Business",
    locations: "frankfurt am main",
    locationsFull: "Frankfurt am Main, Germany",
    year: "2026",
    defaultMeta: "Design, Technology & Business",
    pageMeta: {
      title: {
        home: "Design, Technology & Business | Frankfurt",
        services: "Services — Design, Technology & Business",
        lab: "The Lab — AI, Automation & Digital Tools",
        gallery: "Gallery — Selected Visual Work",
        about: "Design, Technology & Business in Frankfurt",
        contact: "Contact — Start a Project",
        principles: "Our Principles",
        privacy: "Privacy Policy",
        disclaimer: "Legal Disclaimer",
        accessibility: "Accessibility"
      },
      template: {
        about: "About {site} – {title}"
      }
    },
    copyright: "© 2026 thewhizkind",
    signature: "{<powered by thewhizkind>}",
    systemOnline: "System online",
    creativeTechnology: "creative_technology",
    nodes: "frankfurt am main",
    build: "ideas.with_attention()",
    learnMore: "learn more",
    seeMore: "see more",
    back: "back",
    continue: "continue",
    submit: "submit",
    send: "send",
    sending: "sending",
    sent: "sent",
    error: "error",
    required: "required",
    optional: "optional",
    or: "or",
    and: "and",
    with: "with",
    for: "for",
    of: "of",
    to: "to",
    from: "from",
    language: "Language",
    chooseLanguage: "Choose your language",
    explore: "explore",
    visit: "visit",
  },
  de: {
    capabilities: "kernkompetenzen",
    cookies: {
      label: "cookie-einwilligung",
      eyebrow: "cookies",
      text: "wir würden gerne google analytics nutzen, um zu verstehen, wie diese website genutzt wird. es läuft nur, wenn du zustimmst. mehr dazu in unserer",
      link: "datenschutzerklärung",
      decline: "ablehnen",
      accept: "zustimmen"
    },
    siteTitle: "thewhizkind",
    siteDescription: "thewhizkind ist ein unabhängiges Kreativ- und Technologieteam mit Sitz in Frankfurt am Main, das im Bereich Design, Webentwicklung, KI, Automatisierung und Business tätig ist.",
    siteTagline: "Design, Technologie & Business",
    locations: "frankfurt am main",
    locationsFull: "Frankfurt am Main, Deutschland",
    year: "2026",
    defaultMeta: "Design, Technologie & Business",
    pageMeta: {
      title: {
        home: "Design, Technologie & Business | Frankfurt",
        services: "Dienstleistungen — Design, Technologie & Business",
        lab: "Die Werkstatt — AI, Automatisierung & Digitale Werkzeuge",
        gallery: "Galerie — Ausgewählte Grafikprojekte",
        about: "Design, Technologie & Business in Frankfurt",
        contact: "Kontakt — Ein Projekt beginnen",
        principles: "Unsere Prinzipien",
        privacy: "Datenschutzerklärung / Privatsphäre",
        disclaimer: "Impressum / Haftungsausschluss",
        accessibility: "Barrierefreiheit"
      },
      template: {
        about: "Über {site} – {title}"
      }
    },
    copyright: "© 2026 thewhizkind",
    signature: "{<powered by thewhizkind>}",
    systemOnline: "system online",
    creativeTechnology: "creative_technology",
    nodes: "frankfurt am main",
    build: "ideas.mit_aufmerksamkeit()",
    learnMore: "mehr erfahren",
    seeMore: "mehr sehen",
    back: "zurück",
    continue: "weiter",
    submit: "absenden",
    send: "senden",
    sending: "wird gesendet",
    sent: "gesendet",
    error: "fehler",
    required: "erforderlich",
    optional: "optional",
    or: "oder",
    and: "und",
    with: "mit",
    for: "für",
    of: "von",
    to: "an",
    from: "von",
    language: "sprache",
    chooseLanguage: "wähle deine sprache",
    explore: "erkunden",
    visit: "besuchen",
  }
};

export default commonTranslations;